import { AxiosResponse } from "axios";

import { axiosInstance, MessageResponse } from "./common";
import {
  EmployeeDetails,
  CustomerDetails,
  StakeholderContactDetail,
  StakeholderKycDetail,
  BusinessKeyPersonnelDetails,
  BusinessDetails,
} from "./enrichedStakeholder";
import { StakeholderRelationship, StakeholderRelationshipFields } from "./stakeholder_relationships";

export interface StakeholderFields {
  name: string;
  is_potential_perpetrator?: boolean;
  is_classified_fraud?: boolean;
  is_ro_applicable?: boolean;
}

export interface Stakeholder extends StakeholderFields {
  stakeholder_id: string;
}

export interface EnrichedStakeholder {
  stakeholder: Stakeholder;
  relationships?: StakeholderRelationship[];
  customer_details?: CustomerDetails;
  kyc_details?: StakeholderKycDetail[];
  contact_details?: StakeholderContactDetail[];
  business_key_personnel_details?: BusinessKeyPersonnelDetails;
  business_details?: BusinessDetails;
  employee_details?: EmployeeDetails;
}

export interface GetStakeholdersResponse {
  stakeholders: EnrichedStakeholder[];
}

export interface CreateCaseStakeholderRequest {
  stakeholder: StakeholderFields;
  relationships?: StakeholderRelationshipFields[];
  employee_details?: EmployeeDetails;
}

export interface CreateStakeholderRequest {
  stakeholder: StakeholderFields;
  relationships?: StakeholderRelationshipFields[];
  customer_details?: CustomerDetails;
  kyc_details?: StakeholderKycDetail[];
  contact_details?: StakeholderContactDetail[];
  business_key_personnel_details?: BusinessKeyPersonnelDetails;
  business_details?: BusinessDetails;
  employee_details?: EmployeeDetails;
}

export interface CreateStakeholdersRequest {
  stakeholders: CreateStakeholderRequest[];
}

export interface CreateStakeholdersResponse {
  stakeholders: EnrichedStakeholder[];
}

export interface UpdateStakeholderRequest {
  name?: string;
  is_potential_perpetrator?: boolean;
  is_classified_fraud?: boolean;
  is_ro_applicable?: boolean;
}

export const StakeholdersAPI = {
get: async (
  case_id: string,
  stakeholder_ids: string[],
): Promise<GetStakeholdersResponse> => {
  const response: AxiosResponse<GetStakeholdersResponse> =
    await axiosInstance.get(`/v1/cases/${case_id}/stakeholders`, {
      params: {
        stakeholder_ids,
      },
      paramsSerializer: {
        indexes: null,
      },
    });

  return response.data;
},

  add: async (
    case_id: string,
    request: CreateStakeholdersRequest,
  ): Promise<CreateStakeholdersResponse> => {
    const response: AxiosResponse<CreateStakeholdersResponse> =
      await axiosInstance.post(`/v1/cases/${case_id}/stakeholders`, request);

    return response.data;
  },

  update: async (
    case_id: string,
    stakeholder_id: string,
    request: UpdateStakeholderRequest,
  ): Promise<MessageResponse> => {
    const response: AxiosResponse<MessageResponse> =
      await axiosInstance.patch(
        `/v1/cases/${case_id}/stakeholders/${stakeholder_id}`,
        request,
      );

    return response.data;
  },
};